/*=========================================================================================
  File Name: actions.js
  Description: Menus Actions
  ----------------------------------------------------------------------------------------
  Item Name: Fujisushi Web app
  Author: Tan Tran
==========================================================================================*/
import menusService from '../../../services/menus/queries'

export default {
    async getMenusAction( { commit, state }, payload ) {
        let restaurantId = payload.restaurantId;
        await menusService.getMenusByRestaurant(restaurantId)
                          .then( response => {
                              commit('SET_MENUS_STATE', response)
                          });
    },

    async getMenuDetailAction( {commit}, menuId ) {
        await menusService.getMenuDetailById(menuId)
                          .then( response => {
                              commit('SET_CURRENT_MENU_STATE', response)
                          });
    }
}